<template>
    <form-row title="Your MLS Number">
        <input-text
            class="w-full md:w-2/5"
            name="mls_number"
            :value="settings.mls_number"
            placeholder="#"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        settings: { default: () => ({}) },
    },
}
</script>
